/* Build Your Set - extras. Quick add for the carousel cards.
   Standalone: only relies on window.BYS for money/esc helpers, and tells the
   builder about cart changes by dispatching 'cart:updated'. */
(function () {

  function initCard(card) {
    if (card.getAttribute('data-qa-ready') === '1') return;
    card.setAttribute('data-qa-ready', '1');
    var BYS = window.BYS || {};
    var money = BYS.money || function (c) { return '$' + (c / 100).toFixed(2); };
    var esc = BYS.esc || function (s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };
    var handle = card.getAttribute('data-bys-qa');
    var btn = card.querySelector('[data-qa-btn]');
    var defLabel = (btn && btn.getAttribute('data-qa-label')) || 'Quick add';
    var box = card.querySelector('[data-qa-box]');
    if (!handle || !btn || !box) return;
    var swatches = {};
    try { swatches = JSON.parse(card.getAttribute('data-qa-swatches') || '{}'); } catch (e) {}
    var product = null, sel = [];

    function match() {
      if (!product) return null;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) { if (v.options[j] !== sel[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function paint() {
      var html = '';
      var names = (product.options || []).map(function (o) { return (o && o.name) ? o.name : o; });
      names.forEach(function (name, i) {
        var values = [];
        product.variants.forEach(function (v) { if (values.indexOf(v.options[i]) < 0) values.push(v.options[i]); });
        var isColor = /colou?r/i.test(String(name));
        html += '<div class="bys__qa-row" data-qa-i="' + i + '">';
        values.forEach(function (val) {
          var avail = product.variants.some(function (v) { return v.options[i] === val && v.available; });
          var state = (sel[i] === val ? ' aria-pressed="true"' : '') + (avail ? '' : ' disabled');
          var hex = isColor ? swatches[val] : null;
          if (hex) {
            html += '<button type="button" class="bys__qa-sw" data-qa-val="' + esc(val) + '" style="--sw:' + esc(hex) + '"' +
              ' title="' + esc(val) + '" aria-label="' + esc(val) + '"' + state + '></button>';
          } else {
            html += '<button type="button" class="bys__qa-pill" data-qa-val="' + esc(val) + '"' + state + '>' + esc(val) + '</button>';
          }
        });
        html += '</div>';
      });
      var m = match();
      var live = m && m.available;
      html += '<button type="button" class="bys__qa-add" data-qa-add' + (live ? '' : ' disabled') + '>' +
        (live ? 'Add · ' + money(m.price) : 'Unavailable') + '</button>';
      box.innerHTML = html;

      [].slice.call(box.querySelectorAll('.bys__qa-pill, .bys__qa-sw')).forEach(function (p) {
        p.addEventListener('click', function () {
          var i = parseInt(p.parentNode.getAttribute('data-qa-i'), 10);
          sel[i] = p.getAttribute('data-qa-val');
          paint();
        });
      });

      var addB = box.querySelector('[data-qa-add]');
      if (addB) {
        addB.addEventListener('click', function () {
          var m2 = match();
          if (!m2 || !m2.available) return;
          addB.disabled = true; addB.textContent = 'Adding...';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: m2.id, quantity: 1 }] })
          })
            .then(function (r) { if (!r.ok) throw 0; return r.json(); })
            .then(function () {
              addB.textContent = '✓ Added';
              if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) {} }
              // The builder's cart watcher listens for this and repaints tiers.
              document.dispatchEvent(new CustomEvent('cart:updated'));
              setTimeout(function () { box.hidden = true; btn.textContent = defLabel; }, 1400);
            })
            .catch(function () { addB.disabled = false; addB.textContent = 'Try again'; });
        });
      }
    }

    var loading = false;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (loading) return;
      if (!box.hidden) { box.hidden = true; btn.textContent = defLabel; return; }
      btn.textContent = 'Close';
      // Repaint on reopen so a prior '✓ Added' state comes back as a live Add button.
      if (product) { paint(); box.hidden = false; return; }
      loading = true;
      fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (p) {
          loading = false;
          product = p;
          var first = null;
          for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { first = p.variants[i]; break; } }
          sel = ((first || p.variants[0]).options || []).slice();
          paint();
          box.hidden = false;
        })
        .catch(function () { loading = false; btn.textContent = defLabel; });
    });
  }

  /* Peripheral builder bindings, moved here from build-your-set.js for the
     upsert size ceiling. The builder exposes BYS._api before these run
     (script order: core, info, ui, extras). */
  function initPeriph() {
    var BYS = window.BYS || {};
    var api = BYS._api;
    if (!api || api._periphReady) return;
    api._periphReady = true;
    var root = api.root;
    var money = BYS.money, esc = BYS.esc;

    // Slot painting for the rail and the sheet.
    api.slotPaint = function (side, picker, otherPicked) {
      [].slice.call(root.querySelectorAll('[data-bys-slot="' + side + '"]')).forEach(function (slot) {
        var v = picker && picker.variant;
        if (v) {
          var img = (v.featured_image && v.featured_image.src) ||
            (picker.product && picker.product.featured_image);
          slot.classList.add('is-filled');
          slot.classList.remove('is-empty');
          // Compare-at aware: Sandra's permanent 30% DayBasics markdown sets
          // compare_at_price, so the was/now pair appears on its own once the
          // reprice lands. Before that, only the plain price renders.
          var wasP = v.compare_at_price || 0;
          var priceBit = (wasP > v.price ? '<s>' + money(wasP) + '</s> ' : '') + money(v.price);
          slot.innerHTML =
            '<span class="bys__slot-thumb">' + (img
              ? '<img src="' + esc(String(img).replace(/(\.[a-z]+)(\?|$)/i, '_160x160_crop_center$1$2')) + '" alt="" width="54" height="54" loading="lazy">'
              : '') + '</span>' +
            '<span class="bys__slot-t"><b>' + esc(api.styleName(picker)) + '</b>' +
            '<span>' + esc((v.options || []).join(' · ')) + ' · ' + priceBit + '</span></span>' +
            '<button class="bys__slot-x" type="button" data-bys-unpick="' + side + '" aria-label="Remove">&times;</button>';
        } else {
          slot.classList.remove('is-filled');
          slot.classList.add('is-empty');
          var nudge = otherPicked ? 'to lock in ' + money(api.marginal()) + ' off' : '';
          slot.innerHTML =
            '<span class="bys__slotph">' + (side === 'top' ? 'Top' : 'Bottom') + '</span>' +
            '<span class="bys__slot-t"><b>Choose your ' + side + '</b>' +
            (nudge ? '<span>' + nudge + '</span>' : '') + '</span>';
        }
      });
    };

    // Remove buttons are re-created on every paint; delegate instead of rebinding.
    root.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-bys-unpick]') : null;
      if (!btn) return;
      var g = api.active();
      if (!g) return;
      var picker = btn.getAttribute('data-bys-unpick') === 'top' ? g.top : g.bottom;
      picker.styleSel.value = '';
      picker.clear();
      api.repaint();
      // The Remove button just destroyed itself; hand keyboard focus to the
      // matching style select so Tab does not restart from the page top.
      if (picker.styleSel && picker.styleSel.focus) picker.styleSel.focus();
    });

    // Size guide MODAL (dev: never a new tab). Delegated, so the picker link
    // and the FAQ size-chart links all open it; href stays as the no-JS fallback.
    var sgCache = null, sgOpener = null;
    function sgKey(e) {
      var m = document.querySelector('.bys__modal');
      if (!m) return;
      if (e.key === 'Escape' || e.keyCode === 27) { sgClose(); return; }
      if (e.key === 'Tab' || e.keyCode === 9) {
        // Cheap trap: if focus escapes the panel, pull it back to the close button.
        setTimeout(function () {
          var m2 = document.querySelector('.bys__modal');
          if (m2 && !m2.contains(document.activeElement)) m2.querySelector('.bys__modal-x').focus();
        }, 0);
      }
    }
    function sgClose() {
      var m = document.querySelector('.bys__modal');
      if (m) m.parentNode.removeChild(m);
      document.removeEventListener('keydown', sgKey, true);
      var op = sgOpener;
      sgOpener = null;
      if (op && op.focus) {
        op.focus();
        // Third-party overlays (Klaviyo popup) also react to the same Escape and
        // can blur the restored focus a beat later; re-assert once if it fell to body.
        setTimeout(function () {
          if (document.activeElement === document.body && document.body.contains(op)) op.focus();
        }, 80);
      }
    }
    function sgOpen(html) {
      var m = document.createElement('div');
      m.className = 'bys__modal';
      m.innerHTML = '<button class="bys__modal-back" type="button" aria-label="Close size guide"></button>' +
        '<div class="bys__modal-panel" role="dialog" aria-modal="true" aria-label="Size guide">' +
        '<button class="bys__modal-x" type="button" aria-label="Close size guide">&times;</button>' +
        '<div class="bys__modal-body"></div></div>';
      m.querySelector('.bys__modal-body').innerHTML = html;
      root.appendChild(m);
      m.querySelector('.bys__modal-back').addEventListener('click', sgClose);
      m.querySelector('.bys__modal-x').addEventListener('click', sgClose);
      document.addEventListener('keydown', sgKey, true);
      m.querySelector('.bys__modal-x').focus();
    }
    root.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="/pages/pajamas-sizing"]') : null;
      if (!a) return;
      e.preventDefault();
      sgOpener = a;
      if (sgCache) { sgOpen(sgCache); return; }
      fetch('/pages/pajamas-sizing')
        .then(function (r) { if (!r.ok) throw 0; return r.text(); })
        .then(function (htm) {
          var doc = new DOMParser().parseFromString(htm, 'text/html');
          var n = doc.querySelector('#MainContent .rte') || doc.querySelector('#MainContent') || doc.querySelector('main');
          if (!n) throw 0;
          sgCache = n.innerHTML;
          sgOpen(sgCache);
        })
        .catch(function () { window.location.href = a.getAttribute('href'); });
    });

    // Mobile bar hint copy (moved from build-your-set.js for its size ceiling).
    var hintEl = root.querySelector('[data-bys-sticky-hint]');
    api.paintHint = function (built, fresh, marg, haveN, maxN, nextTotal) {
      if (!hintEl) return;
      if (built && fresh) {
        hintEl.innerHTML = 'Adding this set locks in <b>' + money(marg) + ' off</b>';
      } else if (built) {
        if (haveN < maxN) {
          hintEl.innerHTML = 'One more set unlocks <b>' + money(nextTotal) + ' off</b>';
        } else {
          hintEl.textContent = 'Maximum savings unlocked';
        }
      } else if (haveN > 0) {
        hintEl.innerHTML = 'Complete this set to save <b>' + money(marg) + ' more</b>';
      } else {
        hintEl.innerHTML = 'Complete your set to lock in <b>' + money(marg) + ' off</b>';
      }
    };

    // Cart-drawer refresh (moved from build-your-set.js for its size ceiling).
    api.refreshCart = function (openCart) {
      if (typeof window.upcartRefreshCart === 'function') {
        try { window.upcartRefreshCart(); } catch (e) {}
        if (openCart && typeof window.upcartOpenCart === 'function') {
          try { window.upcartOpenCart(); } catch (e) {}
        }
        return;
      }
      document.dispatchEvent(new CustomEvent('cart:build'));
      if (openCart) document.dispatchEvent(new CustomEvent('cart:open'));
    };

    // Cart status line inside the sheet.
    var cartlineEl = root.querySelector('[data-bys-sticky-cartline]');
    var cartCountEl = root.querySelector('[data-bys-sticky-count]');
    api.cartLine = function () {
      if (!cartlineEl) return;
      var c = api.cartData();
      if (!c.count) { cartlineEl.hidden = true; return; }
      cartCountEl.textContent = c.count + (c.count === 1 ? ' item' : ' items') +
        ' in cart · ' + money(c.total) +
        (c.saving > 0 ? ' · Saving ' + money(c.saving * 100) : '');
      cartlineEl.hidden = false;
    };

    // The builder painted before slotPaint existed; repaint now that it does.
    api.repaint();

    [].slice.call(root.querySelectorAll('[data-bys-curated]')).forEach(function (chip) {
      chip.addEventListener('click', function () {
        var gid = chip.getAttribute('data-group');
        if (gid && api.groups[gid]) {
          var tab = root.querySelector('[data-bys-tab="' + gid + '"]');
          if (tab) tab.click();
        }
        var g = api.active(), ok = true;
        [['data-top', g.top], ['data-bottom', g.bottom]].forEach(function (pair) {
          var h = chip.getAttribute(pair[0]); if (!h) return;
          var exists = [].slice.call(pair[1].styleSel.options).some(function (o) { return o.value === h; });
          if (!exists) { ok = false; return; }
          pair[1].styleSel.value = h; pair[1].onStyle();
        });
        if (!ok) api.setError('That set is not available right now. Please pick your pieces above.');
        var railEl = root.querySelector('.bys__rail');
        if (railEl && getComputedStyle(railEl).display !== 'none') {
          railEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });

    [].slice.call(root.querySelectorAll('[data-bys-caro-prev], [data-bys-caro-next]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var strip = btn.parentNode.querySelector('[data-bys-caro]');
        if (!strip) return;
        var dir = btn.hasAttribute('data-bys-caro-prev') ? -1 : 1;
        strip.scrollBy({ left: dir * strip.clientWidth * 0.8, behavior: 'smooth' });
      });
    });

    [].slice.call(root.querySelectorAll('.bys__faq .bys__acc-btn')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.hidden = open;
      });
    });

    (api.agains || []).forEach(function (againEl) {
      againEl.addEventListener('click', function () {
        var tabsEl = root.querySelector('.bys__tabs');
        if (tabsEl) tabsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    if (api.bar && api.barHead && api.sheet) {
      api.barHead.addEventListener('click', function () {
        var open = !api.sheet.hidden;
        api.sheet.hidden = open;
        api.bar.classList.toggle('is-open', !open);
        api.barHead.setAttribute('aria-expanded', String(!open));
      });
    }
    var barView = root.querySelector('[data-bys-sticky-view]');
    if (barView) {
      // Real href=/cart is the keyboard/no-JS path; click upgrades to the drawer.
      barView.addEventListener('click', function (e) {
        if (typeof window.upcartOpenCart === 'function') {
          try { window.upcartOpenCart(); e.preventDefault(); return; } catch (e2) {}
        }
        document.dispatchEvent(new CustomEvent('cart:open'));
      });
    }
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-bys-qa]')).forEach(initCard);
    initPeriph();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
